module.exports = __webpack_public_path__ + "static/media/solo.5efa7b34.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/solo.png
// module id = 39
// module chunks = 0